import { motion } from 'framer-motion';
import { Lock, ExternalLink, Calendar } from 'lucide-react';

const PatreonPostCard = ({ post, index }) => {
  const { title, content, teaser, isPublic, publishedAt, url } = post;

  // Format date for display
  const formatDisplayDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      className="mb-4"
    >
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="group block"
      >
        <div className="relative p-5 rounded-xl bg-[var(--bg-tertiary)]/50 hover:bg-[var(--bg-tertiary)] border border-[var(--bg-elevated)] hover:border-accent/30 transition-all duration-200">
          {/* Member-only badge */}
          {!isPublic && (
            <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2.5 py-1 bg-accent/10 text-accent text-xs font-medium rounded-full">
              <Lock size={12} />
              <span>Members Only</span>
            </div>
          )}

          {/* Title */}
          <h3 className="font-display text-lg text-[var(--text-primary)] group-hover:text-accent transition-colors line-clamp-2 mb-2 pr-24">
            {title}
          </h3>

          {/* Content or Teaser */}
          <p className="text-[var(--text-secondary)] text-sm line-clamp-3 mb-3">
            {isPublic && content ? content : teaser || 'This content is available for patrons.'}
          </p>

          {/* Footer */}
          <div className="flex items-center justify-between">
            {/* Date */}
            <div className="flex items-center gap-1.5 text-[var(--text-muted)] text-sm">
              <Calendar size={14} />
              <span>{formatDisplayDate(publishedAt)}</span>
            </div>

            {/* View on Patreon link */}
            <div className="flex items-center gap-1.5 text-accent text-sm font-medium group-hover:underline">
              <span>View on Patreon</span>
              <ExternalLink size={14} />
            </div>
          </div>
        </div>
      </a>
    </motion.div>
  );
};

export default PatreonPostCard;
